import { useAppContext } from "../_context";

const FieldError = ({ fieldName, allErrors, children, className = "" }) => {
  let found = false;

  if (!Array.isArray(fieldName)) {
    fieldName = [fieldName];
  }

  for (let i = 0; i < fieldName.length; i++) {
    if (Object.keys(allErrors).includes(fieldName[i])) {
      found = true;
    }
  }

  if (!found) {
    return null;
  }

  const [{ tx }] = useAppContext();

  return (
    <div className={`error-field ${className}`}>
      {children || allErrors[fieldName] || tx["Please enter a value"]}
    </div>
  );
};

export default FieldError;
